import { Component, OnInit } from '@angular/core';
import { environment } from '@env/environment';
@Component({
  selector: 'app-sign-in',
  standalone: true,
  templateUrl: './sign-in.component.html',
  styleUrl: './sign-in.component.scss',
})
export class SignInComponent implements OnInit {

  ngOnInit(): void {
    // window.location.href = environment.pingfedAuthUrl;
    // const validation_url = 'https://iapi-test.merck.com/authentication-service/v2/authorize?response_type=token&client_id=asv2-43926117-e50b-4520-8c7f-cd91ff4&scope=default&redirect_uri=http://localhost:4200/verify-token&login_method=sso';
    
    const validation_url = 'https://iapi-test.merck.com/authentication-service/v2/authorize?response_type=token&client_id=asv2-81ddcd6c-9f99-45ac-a168-1b809f2&scope=default&redirect_uri=https://tbt-ussc-dev.healtheq.com/&login_method=sso';
    console.log('BEFORE validation url: ', validation_url);
    window.location.href = validation_url;
    console.log('AFTER validation url: ', validation_url);
    
  }

}
